import React, { useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { useDispatch } from 'react-redux';

// Actions
import { advanceOnboardingStateAction } from 'Shared/actions/onboardingState';

// Components
import { WpIllustration, Illustrations } from 'Wpds/components/illustration';
import ZoomStartScreen from './ZoomStartScreen';
import ZoomInviteScreen from './ZoomInviteScreen';

// Styles
import './ZoomWelcomePage.scss';

enum STEPS {
  welcome = 'welcome',
  invite = 'invite',
}

const ZoomWelcomePage = () => {
  const dispatch = useDispatch();
  const [activeStep, setActiveStep] = useState(STEPS.welcome);

  const handleAddTeammateClick = () => {
    setActiveStep(STEPS.invite);
  };

  const handleSkip = () => {
    dispatch(
      advanceOnboardingStateAction({
        onboardingState: {},
        didSkip: false,
      })
    );
  };

  const handleAdvanceOnboarding = values => {
    const teammateWorkspace = {
      uuid: uuidv4(),
      fullName: values.name,
      email: values.email,
    };

    dispatch(
      advanceOnboardingStateAction({
        onboardingState: {
          workspaces: [teammateWorkspace],
        },
        didSkip: false,
      })
    );
  };

  const baseClaseName = 'ZoomWelcomePage';
  return (
    <div className={baseClaseName}>
      <div className={`${baseClaseName}__header`}>
        <WpIllustration
          className={`${baseClaseName}__header__logo`}
          src={Illustrations.pi_logo_full_red_with_text}
          alt="Predictive Index logo"
        />
      </div>
      <div className={`${baseClaseName}__body`}>
        {activeStep === STEPS.welcome && (
          <ZoomStartScreen handleSkip={handleSkip} handleInviteClick={handleAddTeammateClick} />
        )}
        {activeStep === STEPS.invite && (
          <ZoomInviteScreen handleSkip={handleSkip} handleAdvanceOnboarding={handleAdvanceOnboarding} />
        )}
      </div>
    </div>
  );
};

export default ZoomWelcomePage;
